import axiosInstance from './axiosInstance';

const OfficeAddressService = {
  getOfficeAddresses: () => axiosInstance.get('/api/office-address/'),
  
  getOfficeAddress: (id) => axiosInstance.get(`/api/office-address/${id}/`),
  
  createOfficeAddress: (data, file) => {
    const formData = new FormData();
    formData.append('address_line1', data.address_line1 || '');
    formData.append('address_line2', data.address_line2 || '');
    formData.append('phone_number', data.phone_number || '');
    formData.append('email', data.email || '');
    formData.append('office_hours', data.office_hours || '');

    if (file) {
      formData.append('image', file);
    }

    if (process.env.NODE_ENV === 'development') {
      for (const pair of formData.entries()) {
        // eslint-disable-next-line no-console
        console.debug('[OfficeAddressService] FormData', pair[0], pair[1]);
      }
    }

    return axiosInstance.post('/api/office-address/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  updateOfficeAddress: (id, data, file) => {
    if (file) {
      const formData = new FormData();
      formData.append('address_line1', data.address_line1 || '');
      formData.append('address_line2', data.address_line2 || '');
      formData.append('phone_number', data.phone_number || '');
      formData.append('email', data.email || '');
      formData.append('office_hours', data.office_hours || '');
      formData.append('image', file);

      if (process.env.NODE_ENV === 'development') {
        for (const pair of formData.entries()) {
          // eslint-disable-next-line no-console
          console.debug('[OfficeAddressService] FormData', pair[0], pair[1]);
        }
      }

      return axiosInstance.patch(`/api/office-address/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    const payload = {
      address_line1: data.address_line1 || '',
      address_line2: data.address_line2 || '',
      phone_number: data.phone_number || '',
      email: data.email || '',
      office_hours: data.office_hours || '',
    };

    payload.keep_image = true;
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[OfficeAddressService] PATCH payload', payload);
    }

    return axiosInstance.patch(`/api/office-address/${id}/`, payload);
  },

  deleteOfficeAddress: (id) => axiosInstance.delete(`/api/office-address/${id}/`),
};

export default OfficeAddressService;
